import React from 'react';
import { Icon } from './Icon.js';
export const IconChats = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M10 10H22V22H20L18 19H10V10Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M18 7H16V5H3V18H3.66602L5.62891 14.5098L5.91504 14H7V16.1484L5.12109 19.4902L4.83496 20H1V3H18V7Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconChats.js.map